module.exports = __webpack_public_path__ + "08f159951fd4c5c2dc65c8915be5be6e.jpg";